import { BookOpen, Users, Award, GraduationCap } from "lucide-react"
import SEO from "../SEO"

export default function PranaamKnowledge() {
  return (
    <>
      <SEO
        title="Pranaam Knowledge | Medical Education & Training"
        description="Pranaam Knowledge provides medical education, healthcare training, workshops, CME programs, and certifications for healthcare professionals."
        canonical="https://pranaamhospitals.com/pranaam-knowledge"
      />
    <main className="min-h-screen bg-gray-50">
      <div className="bg-primary text-white py-12 md:py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">Pranaam Knowledge</h1>
          <p className="text-lg md:text-xl text-white/90">Empowering Healthcare Professionals Through Education</p>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="bg-white rounded-xl shadow-sm p-6 md:p-8 mb-8">
          <img src="/wp-content/uploads/2026/05/WomensHealthcareTeam.png" alt="Healthcare Team" className="w-full h-auto max-h-80 object-contain rounded-lg mb-6" />
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Medical Education & Training</h2>
          <p className="text-gray-600 mb-6">
            Pranaam Hospitals is committed to advancing medical education and training in women's and children's healthcare. 
            Our comprehensive programs focus on developing skilled healthcare professionals who deliver exceptional patient care.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <GraduationCap className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Training Programs</h3>
            <p className="text-gray-600">Specialized training in obstetrics, gynecology, and pediatrics</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <Users className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Workshops & CME</h3>
            <p className="text-gray-600">Regular continuing medical education programs and workshops</p>
          </div>

          <div className="bg-white rounded-xl shadow-sm p-6">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-4">
              <Award className="w-8 h-8 text-primary" />
            </div>
            <h3 className="text-xl font-bold mb-3">Certifications</h3>
            <p className="text-gray-600">Accredited certification programs for healthcare professionals</p>
          </div>
        </div>
      </div>
    </main>
    </>
  )
}
